import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@material-ui/core";
import { SideMenuStyles } from "../SideMenuStyles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { LateralBarPages } from "../../../commons/LateralBarOptions";
import { checkIsNullUndefined } from "../../../commons/Utils";
import { SubMenu } from "./SubMenu";
import { useTranslation } from "react-i18next";
import { CorreosIcon } from "../../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../../commons/EnumsGeneral";

export function UserMenu(props) {
  const { user, setShowSideMenu, setSubMenuKey, subMenuKey, setSelected, setResetPage, resetPage, isSpecialUser } = props;
  const classes = SideMenuStyles();
  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  useEffect(() => { }, []);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <List key={"user"} className={classes.menuList}>
      <ListItem
        button
        // key={t("User")}
        onClick={() => handleClick()}
        className={classes.menuListItem}
      >
        <ListItemIcon className={classes.drawerText}>
          <CorreosIcon iconSelected={iconNames.user} iconName="User Icon" iconState="basic" iconScale={2.5} />
        </ListItemIcon>
        <ListItemText
          primary={!checkIsNullUndefined(user) ? user : t("User")}
          primaryTypographyProps={{ noWrap: true }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      {open ? (
        <Collapse
          in={open}
          className={classes.collapseStyle}
          timeout="auto"
          unmountOnExit
        >
          <SubMenu
            code={"user"}
            options={LateralBarPages.User}
            setShowSideMenu={setShowSideMenu}
            setSubMenuKey={setSubMenuKey}
            subMenuKey={subMenuKey}
            setSelected={setSelected}
            setResetPage={setResetPage}
            resetPage={resetPage}
            isSpecialUser={isSpecialUser}
          ></SubMenu>
        </Collapse>
      ) : null}
    </List>
  );
}
